import { Component, input, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnerOrgCountResponse, QueryType } from 'src/app/core/services/analytics.service';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { GridModule } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ExcelModule, GridDataResult } from '@progress/kendo-angular-grid';
import { CustomerMetricsDetailsService } from './services/customers-card.service';
import { DATE_FILTER_OPERATORS } from 'src/app/core/constants/filter-operators';
import { checkIsDemoOrg } from 'src/app/core/models/organizations';

@Component({
  selector: 'app-customers-card',
  standalone: true,
  imports: [CommonModule, DialogsModule, GridModule, ExcelModule],
  templateUrl: './customers-card.component.html',
  styleUrl: './customers-card.component.scss',
  providers: [CustomerMetricsDetailsService],
})
export class CustomersCardComponent {
  // New signal input for the API response
  partnerOrgCount = input<PartnerOrgCountResponse>(new PartnerOrgCountResponse());

  // Keep old inputs for backward compatibility
  @Input() totalCustomers: number = 0;
  @Input() previousCustomers: number = 0;

  public Math = Math;
  public readonly gridService = inject(CustomerMetricsDetailsService);
  public organizationId = input<number | null>();
  public startDate = input<string | null>();
  public endDate = input<string | null>();
  public showPopup = false;
  public dateFilterOperators = DATE_FILTER_OPERATORS;
  queryType = input<QueryType>(QueryType.All);
  selectedOrgIds = input<number[]>([]);

  onContextMenuSelect(event: any) {
    if (event?.text === 'View Data') {
      // Determine query type and org IDs based on filter context
      const queryType = this.queryType().toLowerCase(); // 'all' or 'filtered'
      const orgIds =
        this.queryType() === QueryType.Filtered && this.selectedOrgIds().length > 0
          ? this.selectedOrgIds().join(',')
          : this.organizationId();

      const baseQueryString = `org_ids=${orgIds}&type=${queryType}`;
      const queryString = `${baseQueryString}&current_start=${this.startDate()}&current_end=${this.endDate()}`;

      let demostr = checkIsDemoOrg() ? '/demo' : '';
      this.gridService.url = `${environment.apiUrl}${demostr}/v1/analytics/administrative/customermetricsdetails/`;
      this.gridService.appendQueryString = queryString;
      this.gridService.read();
      this.showPopup = true;
    } else {
      console.warn('Invalid event structure:', event);
    }
  }

  public allData = (): Observable<GridDataResult> => {
    return this.gridService.queryAll();
  };

  // Close popup
  close() {
    this.showPopup = false;
  }
}
